export default function flatMap(array: any[], callback: any) {
  return array.reduce((accumulator: any, item: any) => {
    return accumulator.concat(callback(item));
  }, []);
}
